import { render, staticRenderFns } from "./TheHeading.vue?vue&type=template&id=7b9a9ed0&scoped=true&"
import script from "./TheHeading.vue?vue&type=script&lang=js&"
export * from "./TheHeading.vue?vue&type=script&lang=js&"
import style0 from "./TheHeading.vue?vue&type=style&index=0&id=7b9a9ed0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9a9ed0",
  null
  
)

export default component.exports